var _g, _tspan, _tspan2, _tspan3, _g2, _tspan4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoLight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 2057 619",
    xmlns: "http://www.w3.org/2000/svg",
    "xmlns-xlink": "http://www.w3.org/1999/xlink",
    "xml-space": "preserve",
    "xmlns-serif": "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Artboard1",
    transform: "matrix(1.27382,0,0,1.19024,-2.89429,0.204623)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2.272,
    y: -0.172,
    width: 1614.2,
    height: 519.541,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.78504,0,0,0.840166,-49.6907,38.5077)"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(90,0,0,90,2064.66,462.597)"
  })), /*#__PURE__*/React.createElement("text", {
    x: "633.573px",
    y: "462.597px",
    style: {
      fontFamily: "'AvenirNext-Medium', 'Avenir Next', sans-serif",
      fontWeight: 500,
      fontSize: 90
    }
  }, "Y", _tspan || (_tspan = /*#__PURE__*/React.createElement("tspan", {
    x: "681.363px 736.263px ",
    y: "462.597px 462.597px "
  }, "ou")), "r work.", _tspan2 || (_tspan2 = /*#__PURE__*/React.createElement("tspan", {
    x: "1068.9px 1089.24px 1137.03px 1191.93px ",
    y: "462.597px 462.597px 462.597px 462.597px "
  }, " You")), "r vault.", _tspan3 || (_tspan3 = /*#__PURE__*/React.createElement("tspan", {
    x: "1519.62px 1539.96px 1589.55px 1642.11px ",
    y: "462.597px 462.597px 462.597px 462.597px "
  }, " The")), "ir access.")), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.78504,0,0,0.840166,-67.8516,190.815)"
  }, _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(300,0,0,300,2080.03,129.214)"
  })), /*#__PURE__*/React.createElement("text", {
    x: "641.531px",
    y: "129.214px",
    style: {
      fontFamily: "'AvenirNext-DemiBold', 'Avenir Next', sans-serif",
      fontWeight: 600,
      fontSize: 300
    }
  }, "DocuV", _tspan4 || (_tspan4 = /*#__PURE__*/React.createElement("tspan", {
    x: "1558.03px 1723.03px ",
    y: "129.214px 129.214px "
  }, "au")), "lt")), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(19.6094,0,0,20.9864,-5.77696,6.16052)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3,10.417C3,7.219 3,5.62 3.378,5.082C3.755,4.545 5.258,4.03 8.265,3.001L8.838,2.805C10.405,2.268 11.189,2 12,2C12.811,2 13.595,2.268 15.162,2.805L15.735,3.001C18.742,4.03 20.245,4.545 20.623,5.082C21,5.62 21,7.219 21,10.417L21,11.991C21,17.629 16.761,20.366 14.101,21.527C13.38,21.842 13.019,22 12,22C10.981,22 10.62,21.842 9.899,21.527C7.239,20.366 3,17.629 3,11.991L3,10.417Z",
    style: {
      fill: "rgb(39,59,122)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(19.6094,0,0,20.9864,-5.77696,6.16052)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.554,21.98L8.002,17.429L12.668,14.6L10.847,12.78L16.229,8.913L20.883,13.567C20.184,18.151 16.5,20.479 14.101,21.527C13.528,21.778 13.183,21.929 12.554,21.98Z",
    style: {
      fill: "rgb(18,17,73)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.78504,0,0,0.840166,28.5659,42.915)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M296.439,113.693L171.613,113.693C159.884,113.693 150.376,123.202 150.376,134.93L150.376,377.07C150.376,388.799 159.885,398.307 171.613,398.307L340.387,398.307C352.116,398.307 361.624,388.798 361.624,377.07L361.624,178.878L296.439,113.693Z",
    style: {
      fill: "rgb(0,138,254)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.78504,0,0,0.840166,28.5659,42.915)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 184.785,
    y: 237.416,
    width: 141.234,
    height: 10.261,
    style: {
      fill: "white"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.78504,0,0,0.840166,28.5659,42.915)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 184.785,
    y: 262.775,
    width: 141.234,
    height: 10.261,
    style: {
      fill: "white"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.78504,0,0,0.840166,28.5659,42.915)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 184.785,
    y: 291.306,
    width: 141.234,
    height: 10.261,
    style: {
      fill: "white"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.78504,0,0,0.840166,28.5659,42.915)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 184.785,
    y: 317.871,
    width: 73.635,
    height: 10.261,
    style: {
      fill: "white"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.78504,0,0,0.840166,28.5659,42.915)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M317.676,178.878L361.624,178.878L296.44,113.694L296.44,157.642C296.439,169.37 305.947,178.878 317.676,178.878Z",
    style: {
      fill: "rgb(85,194,249)",
      fillRule: "nonzero"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoLight);
export default __webpack_public_path__ + "static/media/logo_light.45194b250650edc7d8c01bc4ec2dc80e.svg";
export { ForwardRef as ReactComponent };